/* eslint-disable react/jsx-pascal-case */
import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'store'
import T_FormOnly from 'components/4_Templates/T_FormOnly'
import O_SearchBoxChangePassword from 'components/3_Organisms/Groups/O_SearchBoxChangePassword'
import O_AddUser from 'components/3_Organisms/Groups/O_AddUser'
import * as LoginAction from 'slicers/LoginSlice'
import * as PageAction from 'slicers/PageSlice'
import O_AddUserTokui from 'components/3_Organisms/Groups/O_AddUserTokui'

const P_ChangePassword = ({ title }: { title: string }) => {
  // ログインユーザーの種類(0: ジャペル, 1: 仕入先)
  const isJapell = useSelector((state) => state.LoginReducer.isJapell)
  const loginKbn = useSelector((state) => state.LoginReducer.loginKbn)
  const dispatch = useDispatch()
  const history = useHistory()
  useEffect(() => {
    // 仮ログイン状態は許可
    if (loginKbn === 0 || isJapell) {
      dispatch(LoginAction.format())
      history.push('/') // ログイン画面に遷移
    } else {
      dispatch(PageAction.deleteMessage())
    }
  }, [])

  return (
    <T_FormOnly>
      <O_SearchBoxChangePassword title={title} />
      {/* アラートダイアログ */}
      {isJapell ? <O_AddUser refetch={() => {}} /> : <O_AddUserTokui refetch={() => {}} />}
    </T_FormOnly>
  )
}
export default P_ChangePassword
